import * as types from './types';

const initialState = {
  GetProgramMember: {},
  PostProgramMember: {},
  GetDataSystemDropdownValues: {}
};

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case 'RESET_KEY':
      return {
        ...state,
        [action.payload.key]: {}
      };
    case types.GET_PROGRAM_MEMBER_SUCCESS: {
      return {
        ...state,
        GetProgramMember: action.payload
      };
    }
    case types.GET_PROGRAM_MEMBER_FAILURE:
      return { ...state, error: action.payload };

    case types.POST_PROGRAM_MEMBER_SUCCESS: {
      return {
        ...state,
        PostProgramMember: action.payload
      };
    }
    case types.POST_PROGRAM_MEMBER_FAILURE:
      return { ...state, error: action.payload };

    case types.GET_DATA_SYSTEM_DROPDOWN_SUCCESS: {
      return {
        ...state,
        GetDataSystemDropdownValues: action.payload
      };
    }
    case types.GET_DATA_SYSTEM_DROPDOWN_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
